import { trackEvent } from '@patrianna/analytics'
import { IconButton } from '@patrianna/core-components'
import { cleanDialogStack, closeLatestDialog } from '@patrianna/dialog-manager'
import { CloseCircle } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import classes from './styles.module.scss'

type Props = {
  callBack?: () => void
  closeAll?: boolean
  className?: string
  trackEventName?: string
}

function CloseModalButton(props: Props) {
  const { closeAll } = props

  const handleTrackEvent = (targetName: string) => {
    trackEvent(targetName)
  }

  const onClick = () => {
    if (closeAll) {
      cleanDialogStack()
    } else {
      closeLatestDialog()
    }

    if (props.trackEventName) {
      handleTrackEvent(props.trackEventName)
    }
  }

  return (
    <IconButton
      onClick={() => {
        if (props?.callBack) {
          props.callBack()
        }
        onClick()
      }}
      className={cx(classes.close, props?.className)}
      dataTestId='close-modal-button'
    >
      <CloseCircle />
    </IconButton>
  )
}

export default CloseModalButton
